<template>
  <div class="task taskWaitingProcess"></div>
</template>

<script>
import * as api from '../../utils/api'
import language from '../../language'

export default {
  name: 'definition-task-waiting-process',
  props: [
    'task',
    'definition',
    'object',
    'taskRefresh',
    'definitionContentId',
    'repeatableGroupCode',
    'languageSelected',
    'newEval',
    'language',
    'authorization',
    'type',
    'editRepeatableWaitProcess'
  ],
  data () {
    return {
      processOK: false
    }
  },
  methods: {
    callTask () {
      api.call({domainEndpoint: this.type.domainEndpoint, url: this.task.type.endpoint, token: this.type.token, version: this.type.version, method: 'POST', lang: this.getLang(), authorization: this.authorization, data: { id: this.definitionContentId, code: this.repeatableGroupCode }})
        .then(resp => {
          if (resp.requestResult) {
            this.processOK = true
          } else {
            this.processOK = false
          }
          this.$emit('waitingProcessFinished', this.processOK, this.repeatableGroupCode)
        })
        .catch(err => {
          console.log(err)
          this.processOK = false
          this.$emit('waitingProcessFinished', this.processOK, this.repeatableGroupCode)
        })
    },
    getLang (key) {
      return language(this.language, key)
    }
  },
  watch: {
    editRepeatableWaitProcess (value) {
      if (value) {
        this.$emit('waitingProcessInit')
        this.callTask()
      }
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// node_modules/vue-definition/src/components/item/task/taskWaitingProcess.vue